/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireIpaqSf {
  position: number;
  question: string;
  answers: string[];
}

export const Q_IPAQ_SF: QuestionnaireIpaqSf[] = [
  {
    position: 1, question: 'a. Negli ultimi 7 giorni, per quanti giorni ha compiuto attività fisiche INTENSE, ' +
      'come ad esempio sollevamento di pesi, lavori pesanti in giardino, ' +
      'attività aerobiche come corse o giri in bicicletta a velocità sostenuta?' ,
    answers: [null]
  },
  {
    position: 2, question: 'b. Quanto tempo in totale, normalmente, ' +
      'lei ha trascorso compiendo attività fisiche INTENSE in uno di questi giorni?' ,
    answers: [null]
  },
  {
    position: 3, question: 'a. Negli ultimi 7 giorni, per quanti giorni ha compiuto attività fisiche MODERATE, ' +
      'come ad esempio trasporto di pesi leggeri, giri in bicicletta ad una velocità regolare, ' +
      'attività in palestra, lavoro in giardino, lavoro fisico prolungato in casa? Non consideri le camminate' ,
    answers: [null]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'b. Quanto tempo in totale, normalmente, ' +
      'lei ha trascorso compiendo attività fisiche MODERATE in uno di questi giorni?' ,
    answers: [null]
  },
  {
    position: 5, question: 'a. Negli ultimi 7 giorni, per quanti giorni ha camminato per almeno 10 minuti? ' +
      '(Consideri le camminate compiute al lavoro e a casa, quelle per spostarsi da un posto ad un altro ' +
      'ed ogni altra camminata che le è capitato di fare per piacere, esercizio o sport)',
    answers: [null]

  },
  {
    position: 6, question: 'b. Quanto tempo in totale, normalmente, lei ha camminato in uno di questi giorni?',
    answers: [null]

  },
  {
    position: 7, question: 'c. A che passo ha camminato prevalentemente?',
    answers: [
      'Passo INTENSO, che l’ha fatta respirare ad un ritmo molto più elevato del normale',
      'Passo MODERATO, che l’ha fatta respirare ad un ritmo solo moderatamente più elevato del normale',
      'Passo LENTO, senza alcun cambiamento nel suo ritmo di respiro'
    ]
  },
  {
    position: 8, question: 'a. Negli ultimi 7 giorni, quanto tempo in totale lei ha trascorso rimanendo seduto, ' +
      'durante un giorno lavorativo? (includa attività svolte al lavoro, a casa, ' +
      'mentre si recava la lavoro e durante il tempo libero: es. ad una scrivania, ' +
      'a tavola, mentre stava visitando degli amici, alla TV, leggendo)',
    answers: [null]
  },
  {
    position: 9, question: 'b. Negli ultimi 7 giorni, quanto tempo in totale ha trascorso rimanendo seduto, ' +
      'durante un giorno del fine settimana?',
    answers: [null]
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class IPAQSFResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  diagnosis: string;

  constructor(doctorID: string, patientSSN: string, results: string[], diagnosis: string) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.diagnosis = diagnosis;
  }

}
